
define('text!templates/pages/dashboard/balance.ejs',[],function () { return '<span>Текущий баланс:&nbsp;</span><span class="<% if (value<0) { %>text-important<% } else { %>text-success<% } %>"><%= money(value) %>&nbsp;<small><%= currencyCode %></small></span>\n<% if (value<0) { %><br><span class="balance-message">Необходимо срочно пополнить баланс.</span><% } %>';});

